import { render, staticRenderFns } from "./platformManagement.vue?vue&type=template&id=6614f288&scoped=true&"
import script from "./platformManagement.vue?vue&type=script&lang=js&"
export * from "./platformManagement.vue?vue&type=script&lang=js&"
import style0 from "./platformManagement.vue?vue&type=style&index=0&id=6614f288&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6614f288",
  null
  
)

export default component.exports